import { t } from '@lingui/core/macro';
import { Camera, ChevronLeft } from 'lucide-react';
import { CaptureActionRail, CaptureRailSecondaryButton, CaptureShutterButton } from '@/components/CaptureActionRail';

interface IllustrationOverlayProps {
  illustrationUrl: string;
  stepTitle: string;
  stepDescription: string;
  onOk: () => void;
  onBack: () => void;
}

/**
 * Illustration overlay component shown before camera capture
 * Displays step illustration with title and description on white background
 * Matches the example_illustration.png design
 */
export function IllustrationOverlay({
  illustrationUrl,
  stepTitle,
  stepDescription,
  onOk,
  onBack,
}: IllustrationOverlayProps) {
  return (
    <div className="capture-illustration flex bg-white">
      <div className="flex-1 relative flex flex-col min-w-0 min-h-0 bg-white">
        <div className="px-4 pt-4 pb-2">
          <h2 className="text-xl font-bold text-blue-600 mb-1">{stepTitle}</h2>
          <p className="text-sm text-gray-700">{stepDescription}</p>
        </div>

        <div className="px-4 pb-4 flex-1 min-h-0 flex items-center">
          <img src={illustrationUrl} alt={stepTitle} className="max-h-full max-w-full min-h-0 object-contain" />
        </div>
      </div>

      <CaptureActionRail surface="light">
        <CaptureShutterButton tone="green" surface="light" onClick={onOk} aria-label={t`Continue to camera`}>
          <Camera className="w-8 h-8 text-white" />
        </CaptureShutterButton>

        <CaptureRailSecondaryButton onClick={onBack} aria-label={t`Back`}>
          <ChevronLeft className="w-6 h-6 text-white" />
        </CaptureRailSecondaryButton>
      </CaptureActionRail>
    </div>
  );
}
